module.exports = __webpack_public_path__ + "static/icon_opnv-1288f9edb1a2fe3500b51d3c1b0a96d6.png";